import { Col, Menu, Row } from 'antd'
import classnames from 'classnames'
import { memo, useMemo } from 'react'
import { Outlet, useMatch, useNavigate } from 'react-router-dom'

export default memo(function ProjectMemberIndex() {
  const navigate = useNavigate()
  const match = useMatch('/main/:projectType/:projectId/:key')
  const activeKey = useMemo(() => match?.params.key || '', [match])

  return (
    <div className={classnames('container-xl', 'p-2')}>
      <Row gutter={16} wrap={false}>
        <Col flex={' 0 0 250px'}>
          <Menu
            mode='inline'
            selectedKeys={[activeKey]}
            onSelect={({ key }) => {
              navigate(key)
            }}
          >
            <Menu.Item key='members'>Default Members</Menu.Item>
            <Menu.Item key='outside-collaborators'>Invited Members</Menu.Item>
            <Menu.Item key='pending-invitations'>Pending Invitations</Menu.Item>
            <Menu.Item key='failed-invitations'>Failed Invitations</Menu.Item>
          </Menu>
        </Col>
        <Col flex={'auto'}>
          <Outlet />
        </Col>
      </Row>
    </div>
  )
})
